import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Form } from 'react-bootstrap';
import './styles/ListPageConfigSelect.scss';



function ListPageConfigSelect({page, onChange, ...props}) {
  const [value, setValue] = useState(props.value);

  const handleChange = selected => {
    setValue(selected.map(item => item.value));
    onChange(page, selected);
  }

  return (
    <Form.Group className={`list-page-select ${page}`} controlId={`form_${page}`}>
      <Form.Label >{page.titleize()} Columns</Form.Label>
      <Select
        hideSelectedOptions
        multi
        clearable={false}
        value={value}
        onChange={handleChange}
        name={page}
        optionRenderer={(option => (
          <div className={option.group ? 'option-group' : 'option-option'}>
            {option.label}
          </div>
        ))}
        options={props.options}
      />
      {value.length > 5 && page === 'billing_students' && (
        <Form.Text className="error">
          A maximum of 5 columns is supported. The extra columns will not be displayed.
        </Form.Text>
      )}
    </Form.Group>
  )
}

ListPageConfigSelect.propTypes = {
  page: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default ListPageConfigSelect
